import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from "@mantine/core";
import { ChatView } from "../views/Chat/ChatView.js";
import { ErrorBoundary } from "./ErrorBoundary.js";
import { LayersView } from "../views/Layers/LayersView.js";
import { SourcesView } from "../views/Sources/SourcesView.js";
import { VersionsView } from "../views/Versions/VersionsView.js";
import { SettingsView } from "../views/Settings/SettingsView.js";
import { MarkersView } from "../views/Markers/MarkersView.js";
export const PanelView = ({ view, onViewChange }) => {
    if (view === "layers") {
        return _jsx(LayersView, { onViewChange: onViewChange });
    }
    if (view === "sources") {
        return _jsx(SourcesView, { onViewChange: onViewChange });
    }
    if (view === "markers") {
        return _jsx(MarkersView, { onViewChange: onViewChange });
    }
    if (view === "versions") {
        return _jsx(VersionsView, { onViewChange: onViewChange });
    }
    if (view === "settings") {
        return _jsx(SettingsView, { onViewChange: onViewChange });
    }
    return;
};
export const StyleEditorSidebar = ({ view, onViewChange }) => {
    return (_jsx(ErrorBoundary, { children: _jsxs(Flex, { h: "100%", w: "100%", gap: "md", children: [_jsx(ChatView, {}), _jsx(PanelView, { view: view, onViewChange: onViewChange })] }) }));
};
